<template>
  <hic-dialog append-to-body :close-on-click-modal="false" title="入院登记" @open="open" :visible="visible" @close="close" width="65rem">
    <el-form class="left" ref="editor" :rules="rules" size="small" :model="entity" label-width="8rem">
      <el-row>
        <el-col :span="24">
          <el-form-item label="入住床位" prop="bedId">
            <el-cascader v-model="selectedBed" size="small" :options="bedOptions" :props="{ expandTrigger: 'hover', multiple: false, emitPath: true, value: 'code', label: 'text' }" @change="bedChange" class="f-w"></el-cascader>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item label="入院科室" prop="deptCode">
            <hic-dict-selector dict-type="Dept" v-model="entity.deptCode"></hic-dict-selector>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="8">
          <el-form-item label="入院病区" prop="wardCode">
            <hic-dict-selector dict-type="IpWard" v-model="entity.wardCode" placeholder="请选择" @change="wardChange"></hic-dict-selector>
          </el-form-item>
        </el-col> -->
        <el-col :span="8" style="height: 51px">
          <el-form-item label="姓名" prop="patientName">
            <el-input maxlength="200" v-model="entity.patientName" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="patientGender">
            <hic-dict-selector v-model="entity.patientGender" auto dict-type="Gender" class="edit-select" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="年龄" prop="patientAge">
            <el-input maxlength="30" v-model="entity.patientAge" clearable type="number" @blur="ageChange"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="民族" prop="ethnicity">
            <hic-dict-selector dict-type="Ethnicity" v-model="entity.ethnicity" placeholder="请选择" auto></hic-dict-selector>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="传染病" prop="epidemicsList">
            <hic-text-selector dict-type="Epidemic" v-model="entity.epidemicsList" placeholder="请选择" :multiple="true" @change="changeEpidemic"></hic-text-selector>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="新冠" prop="covid19">
            <hic-dict-selector dict-type="Covid19" v-model="entity.covid19" placeholder="请选择" auto></hic-dict-selector>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="药物过敏" prop="">
            <hic-text-selector dict-type="AllergyDrugs" v-model="entity.allergyDrugsList" placeholder="请选择" multiple></hic-text-selector>
          </el-form-item>
        </el-col>
        <template v-if="setting.isSimple">
          <el-col :span="8">
            <el-form-item label="体温" prop="temperature">
              <el-input maxlength="6" type="number" v-model="entity.temperature" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="症状" prop="symptoms">
              <el-input v-model="entity.symptoms" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出生年月日" prop="birthDate">
              <el-date-picker v-model="entity.birthDate" style="width: 100%;" type="date" size="small"
                value-format="yyyy-MM-dd" placeholder="选择出生年月日" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="分组" prop="groupType">
              <hic-dict-selector dict-type="PatientGroup" is-enum v-model="entity.groupType"
                placeholder="请选择"></hic-dict-selector>
            </el-form-item>
          </el-col>
        </template>

        <el-col :span="8">
          <el-form-item label="目标分级" prop="">
            <hic-dict-selector dict-type="TargetGrade" v-model="entity.targetGrade" placeholder="请选择" ></hic-dict-selector>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="责任医师" prop="doctorCode">
            <hic-staff-selector :dept="entity.deptCode" v-model="entity.doctorCode" :name.sync="entity.doctorName" class="f-w"></hic-staff-selector>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item label="责任护士" prop="nurseCode">
            <hic-staff-selector :dept="entity.deptCode" v-model="entity.nurseCode" :name.sync="entity.nurseName" class="f-w"></hic-staff-selector>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="证件号码" prop="patientIdNo">
            <el-input maxlength="200" v-model="entity.patientIdNo" placeholder="证件号码" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="入院时间" prop="">
            <el-date-picker v-model="entity.startDate" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss" style="width: 12rem"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="办案人单位" prop="contactCompany">
            <el-input maxlength="30" v-model="entity.contactCompany" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="办案人" prop="contactName">
            <el-input maxlength="30" v-model="entity.contactName" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话" prop="contactPhone">
            <el-input maxlength="30" v-model="entity.contactPhone" clearable style="width: 80%"></el-input>
            <el-button v-if="!setting.isSimple" @click="addContact" icon="el-icon-plus" size="mini" type="primary" circle plain class="left-pad"></el-button>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="接收既往病历" prop="ifMedicalRecordReceived">
            <el-radio-group v-model="entity.ifMedicalRecordReceived" @input="changedMedicalRecordReceived">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="接收人" prop="medicalRecordReceivedUserCode">
            <hic-staff-selector :dept="entity.deptCode" v-model="entity.medicalRecordReceivedUserCode" :name.sync="entity.medicalRecordReceivedUserName" :disabled="!entity.ifMedicalRecordReceived" class="f-w"></hic-staff-selector>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="接收日期" prop="medicalRecordReceivedDate">
            <el-date-picker v-model="entity.medicalRecordReceivedDate" style="width: 100%;" type="date" size="small" value-format="yyyy-MM-dd" placeholder="接收日期" :disabled="!entity.ifMedicalRecordReceived" />
          </el-form-item>
        </el-col>
        <el-col :span="24" class="center danger"> 注意：办案人需录入非借调在编干部 </el-col>
      </el-row>
      <el-row v-for="(item, index) in contacts" :key="index">
        <el-col :span="8">
          <el-form-item label="办案人单位" prop="contactCompany">
            <el-input maxlength="30" v-model="item.address" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="办案人" prop="contactName">
            <el-input maxlength="30" v-model="item.name" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话" prop="contactPhone">
            <el-input maxlength="30" v-model="item.phone" clearable style="width: 80%"></el-input>
            <el-button @click="delContact(item)" icon="el-icon-delete" size="mini" type="danger" circle plain class="left-pad"></el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button type="info" @click.native="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="save">提 交</el-button>
    </template>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      entity: Object,
    },
    data() {
       // 自定义体温验证函数（核心适配）
    const validateTemperature = (rule, value, callback) => {
      // 去除首尾空格
      const tempValue = (value || '').toString().trim();

      // 空值已由 required 规则校验
      if (tempValue) {
        // 1. 校验是否为有效数字（支持整数、一位/两位小数，如 36、36.5、36.55）
        const numReg = /^(\d{2})(\.\d{1,2})?$/;
        if (!numReg.test(tempValue)) {
          return callback(new Error('体温格式错误，请输入有效数字（如 36、36.5）'));
        }

        // 2. 转换为数字并校验范围（35.0℃ ~ 42.0℃）
        const tempNum = parseFloat(tempValue);
        if (tempNum < 35.0) {
          return callback(new Error('体温过低，正常范围为 35.0℃ ~ 42.0℃'));
        }
        if (tempNum > 42.0) {
          return callback(new Error('体温过高，正常范围为 35.0℃ ~ 42.0℃'));
        }
      }
      // 验证通过
      callback();
    };
      return {
        freeBeds: [],
        selectedBed: [],
        contacts: [],
        rules: {
          patientName: [{ required: true, message: "请填写姓名", trigger: "blur" }],
          patientAge: [{ required: true, message: "请填写年龄", trigger: "blur" }],
          patientGender: [{ required: true, message: "请选择性别", trigger: "blur" }],
          patientIdNo: [{ required: true, message: "请填写证件号码", trigger: "blur" }],
          contactCompany: [{ required: true, message: "请填写办案人单位", trigger: "blur" }],
          contactName: [{ required: true, message: "请填写办案人", trigger: "blur" }],
          contactPhone: [{ required: true, message: "请填写联系电话", trigger: "blur" }],
          deptCode: [{ required: true, message: "请选择科室", trigger: "change" }],
          wardCode: [{ required: true, message: "请选择病区", trigger: "change" }],
          bedId: [{ required: true, message: "请选择床位", trigger: "change" }],
          doctorCode: [{ required: true, message: "请选择医师", trigger: "change" }],
          nurseCode: [{ required: false, message: "请选择护士", trigger: "change" }],
          epidemicsList: [{ required: true, message: "请选择传染病", trigger: "change" }],
          covid19: [{ required: true, message: "请选择新冠", trigger: "change" }],
          groupType: [{ required: true, message: "请选择分组", trigger: "change" }],
          symptoms: [{ required: true, message: "请输入", trigger: "change" }],
          temperature: [{ required: true, message: "请输入", trigger: "change" }, { validator: validateTemperature, trigger: ["blur", "change"] }],
          birthDate: [{ required: true, message: "请选择出生年月日", trigger: "change" }],
        },
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum", "user", "setting"]),
      bedOptions() {
        let list = [];
        if (this.freeBeds.length) {
          let beds = this.freeBeds.map((i) => ({ code: i.id + "", text: i.no, value: i.id + "", parentCode: i.room, parentType: "Room", type: "Bed" }));
          let rooms = this.dict.Room.filter((i) => beds.findIndex((b) => b.parentCode == i.code) > -1);
          let floors = this.dict.Floor.filter((i) => rooms.findIndex((b) => b.parentCode == i.code) > -1);
          let buildings = this.dict.Building.filter((i) => floors.findIndex((b) => b.parentCode == i.code) > -1);
          list.push(...buildings);
          list.push(...floors);
          list.push(...rooms);
          list.push(...beds);
          return this.$utils.Cascade.make(list);
        }
        return [];
      },
      // bedOptions() {
      //   let beds = [];
      //   for (let bed of this.freeBeds.filter((i) => !this.entity?.wardCode || i.wardCode == this.entity.wardCode)) {
      //     let { building, floor, room, no, id } = bed;
      //     let b = beds.find((item) => item.value == building);
      //     if (!b) {
      //       b = {
      //         value: building,
      //         label: this.$utils.Dict.text(building, "Building"),
      //         children: [],
      //       };
      //       beds.push(b);
      //     }
      //     let f = b.children.find((item) => item.value == floor);
      //     if (!f) {
      //       f = {
      //         value: floor,
      //         label: this.$utils.Dict.text(floor, "Floor"),
      //         children: [],
      //       };
      //       b.children.push(f);
      //     }
      //     let r = f.children.find((item) => item.value == room);
      //     if (!r) {
      //       r = {
      //         value: room,
      //         label: this.$utils.Dict.text(room, "Room"),
      //         children: [],
      //       };
      //       f.children.push(r);
      //     }
      //     let n = r.children.find((item) => item.value == no);
      //     if (!n) {
      //       n = {
      //         value: id,
      //         label: no,
      //       };
      //       r.children.push(n);
      //     }
      //   }
      //   return beds;
      // },
    },
    methods: {
      open() {
        try {
          this.entity.patientIdNo = "";
          this.$refs.editor.resetFields();
          if (this.selectedBed) this.selectedBed = [];
        } catch (error) {}

        api.Bed.query({
          nulls: "ipNo",
        }).then((res) => {
          this.freeBeds = res.items;
        });
        this.entity.startDate = this.$utils.Dt.now();
      },
      close() {
        this.$emit("update:visible", false);
      },
      dateBrithday(val) {
        if (val) {
          let _arr = val.split('-')
          return _arr[0] + '-' + _arr[1]
        }
      },
      save() {
        this.$refs.editor.validate((valid) => {
          if (valid) {
            let patient = {
              name: this.entity.patientName,
              gender: this.entity.patientGender,
              ethnicity: this.entity.ethnicity,
              birthday: this.entity.patientBirthday,
              idType: "入住号", // 固定字典编码，需要字典数据配合
              idNo: this.entity.patientIdNo || this.entity.patientName,
              groupType: this.entity.groupType || null,
              symptoms: this.entity.symptoms || null,
              temperature: this.entity.temperature || null,
              birthDate:this.entity.birthDate || null,
              ifMedicalRecordReceived: this.entity.ifMedicalRecordReceived || null,
              medicalRecordReceivedUserCode: this.entity.medicalRecordReceivedUserCode || null,
              medicalRecordReceivedUserName: this.entity.medicalRecordReceivedUserName || null,
              medicalRecordReceivedDate: this.entity.medicalRecordReceivedDate || null,
            };            
            api.Patient.save(patient) // 保存患者
              .then((res) => {
                this.saveContact(res); // 保存联系人
                this.entity.patientCode = res.id;
                this.entity.patientIdNo = res.idNo;
                this.entity.originalDeptCode = this.entity.deptCode;
                this.entity.originalWardCode = this.entity.wardCode;
                this.entity.state = "已登记";
                this.entity.ignoreUserCheck = true;
                this.entity.epidemic = this.entity.epidemicsList.join(",");
                this.entity.allergyDrugs = this.entity.allergyDrugsList ? this.entity.allergyDrugsList.join(",") : '';
                this.entity.birthDate = patient.birthDate || null

                return api.Hospitalization.save(this.entity); // 入住登记
              })
              .then((res) => {
                this.entity.id = res.id;
                return api.Hospitalization.checkIn(this.entity.id, this.entity); // 入科操作
              })
              .then((res) => {
                this.$emit("saved", res);
                this.$message.success("保存成功！");
                this.$emit("update:visible", false);
              })
              .catch((err) => {
                // 如果出错了要删除已经生成的住院记录和患者
                this.clear();
                this.$message.error(err);
              });
          } else {
            return false;
          }
        });
      },
      wardChange() {
        this.$set(this.entity, "bedId", null);
        this.$set(this.entity, "bedNo", null);
        this.$set(this.entity, "patientName", null);
      },
      bedChange(site) {
        // 床位
        this.entity.bedId = site[3];

        if (this.entity.bedId) {
          // 楼层 = 科室
          if (this.dict.Dept.findIndex((d) => d.code == site[1]) > -1) {
            this.entity.wardCode = site[1];
          }
          let bed = this.freeBeds.find((b) => b.id == this.entity.bedId);
          if (bed) {
            this.entity.bedId = bed.id;
            this.entity.bedNo = bed.no;
            if (!this.entity.wardCode) {
              this.entity.wardCode = bed.wardCode;
            }
            // 生成姓名
            this.$set(
              this.entity,
              "patientName",
              this.$utils.Dt.now()
                .replace(/[-,  ,:]/g, "")
                .substring(2, 12) +
                "-" +
                this.entity.bedNo
            );
          } else {
            this.entity.bedId = null;
          }
        } else {
          this.wardChange();
        }
      },
      ageChange() {
        let nowYear = this.$utils.Dt.today().substring(0, 4);
        let birthYear = parseInt(nowYear) - parseInt(this.entity.patientAge);
        this.$set(this.entity, "patientBirthday", birthYear + "-01-01");
      },
      addContact() {
        this.contacts.push({ address: this.entity.contactCompany });
      },
      delContact(row) {
        this.contacts.splice(this.contacts.indexOf(row), 1);
      },
      saveContact(patient) {
        let contacts = this.contacts.filter((c) => c.name && c.phone);
        contacts.unshift({
          name: this.entity.contactName,
          phone: this.entity.contactPhone,
          address: this.entity.contactCompany,
        });
        contacts.forEach((c) => {
          c.patientCode = patient.id;
          c.relation = "办案人"; // 固定字典编码，需要字典数据配合
          api.PatientContact.save(c);
        });
      },
      clear() {
        if (this.entity.id) {
          api.Hospitalization.del(this.entity.id);
          this.entity.id = null;
        }
        // 后台删除患者时会关联删除联系人及卡包
        if (this.entity.patientCode) {
          api.Patient.del(this.entity.patientCode);
          this.entity.patientCode = null;
        }
      },
      changeEpidemic(val) {
        if(val.indexOf('无') > -1) this.entity.epidemic = ['无']
        else if(val.indexOf('未确定') > -1) this.entity.epidemic = ['未确定']
        // this.entity.epidemic = this.entity.epidemic.join(",");
      },
      changedMedicalRecordReceived(val) {
        if (!val) {
          this.entity.medicalRecordReceivedUserCode = null;
          this.entity.medicalRecordReceivedUserName = null;
          this.entity.medicalRecordReceivedDate = null;
        }
      },
    },
  };
</script>
